import React from "react";

const AboutCompany = () => {
  return (
    <React.Fragment>
      {/* App-Solution-Section-Start */}
      <section className="h2_nh_about-area pt-100 pb-100 nh_light_bg nh_border_bottom">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="nh_about-img mr-15 mb-30 mb-lg-0">
                <img src="/images/about-us-4.png" alt="" className="w-100" />
              </div>
            </div>
            <div className="col-lg-6">
              <div className="nh_about-left ml-20">
                <div className="nh_section-area">
                  <span className="nh_section-subtitle">About us</span>
                  <h2 className="nh_section-title mb-15 pb-2">
                    Welcome to NexPe – Your Trusted Recharge Partner!
                  </h2>
                  <p className="nh_section-text">
                    At NexPe, powered by FINGTEL COMMUNICATIONS, we are
                    dedicated to simplifying digital payments for millions of
                    users across India. Our platform offers seamless recharge
                    solutions for mobile, DTH, and Google Play services,
                    ensuring speed, security, and reliability at every step.
                  </p>
                  <p className="nh_section-text mb-25 pb-2">
                    We believe in empowering our users by making digital
                    payments simple, secure, and efficient. With NexPe, powered
                    by the expertise of FINGTEL COMMUNICATIONS, we aim to create
                    a hassle-free recharge experience for every individual and
                    business.
                  </p>
                </div>
                <div className="nh_about-btn">
                  <a href="/about_us" className="nh_theme-btn">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* App-Solution-Section-end */}
    </React.Fragment>
  );
};

export default AboutCompany;
